export const forbiddenPlanNameWords = [
  'blue',
  'bcbs',
  'blue cross',
  'blue shield',
  'unitedhealth',
  'united health',
  'unitedhealthcare',
  'united health care',
  'united',
  'select',
  'uhc',
  'cigna',
  'aetna',
  'humana',
  'hsa',
  'kaiser',
  'kaiser permanente',
  'anthem',
  'elevance',
  'centene',
  'cvs health',
  'highmark',
  'molina',
  'bright',
  'oscar',
  'horizon',
  'independence',
  'regence',
  'intermountain',
  'medica',
  'priority',
  'excellus',
  'wellmark',
  'emblem',
  'emblemhealth',
  'premera',
  'healthpartners',
  'mutual',
  'plan match',
  'match'
]
